<template>

  <div>
    <h3 v-if="!institute.Logo" style="width: 100%; text-align: center">Loading...</h3>
    <table v-else>
      <thead>
        <tr>
          <td style="width: 12%">
            <img :src="institute.Logo" style="width: 85%" />
          </td>
          <th style="width: 76%; background-color:white; vertical-align: middle;">
            <h3 style="margin-bottom: -1px !important">{{institute.Name}}</h3>
            <label>{{institute.Address}} {{institute.Contact}} </label>
            <h4 class="p-t-b">{{h1}}</h4>
            <h5 class="p-t-b">{{h2}}</h5>
            <h5 class="p-t-b">{{h3}}</h5>
            <h5 class="p-t-b">{{h4}}</h5>
            <h5 class="p-t-b">{{h5}}</h5>
          </th>
          <td style="width: 12%; vertical-align: bottom; text-align: right">
            <small>by: {{report.By}}</small>
            <br />
            <small>on: {{report.On}}</small>
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <hr />
          </td>
        </tr>
      </thead>
    </table>
  </div>
</template>

<script>

  const axios = require('axios').default;

  export default {
    props: {
      h1: String,
      h2: String,
      h3: String,
      h4: String,
      h5: String,
    },
    data() {
      return {
        institute: {
          Name: '',
          Logo: '',
          Address: '',
          Contact: ''
        },

        By: '',
        On: '',   
      }
    },

    created: function () {
      var vm = this; 
      axios.post('/api/RoleApi/loadHeader')
        .then(function (res) {
          vm.institute = res.data.institute;
          vm.report = res.data.report;
        });
    }
  }
</script>

<style scoped>
  .p-t-b {
    margin-top: 5px;
    margin-bottom: 5px;
  }

  small{
    font-size: 8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/core/header.vue